"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuburbPerformanceDtoDemandLevelEnum = void 0;
exports.instanceOfSuburbPerformanceDto = instanceOfSuburbPerformanceDto;
exports.SuburbPerformanceDtoFromJSON = SuburbPerformanceDtoFromJSON;
exports.SuburbPerformanceDtoFromJSONTyped = SuburbPerformanceDtoFromJSONTyped;
exports.SuburbPerformanceDtoToJSON = SuburbPerformanceDtoToJSON;
exports.SuburbPerformanceDtoToJSONTyped = SuburbPerformanceDtoToJSONTyped;
/**
 * @export
 */
exports.SuburbPerformanceDtoDemandLevelEnum = {
    High: 'high',
    Medium: 'medium',
    Low: 'low'
};
/**
 * Check if a given object implements the SuburbPerformanceDto interface.
 */
function instanceOfSuburbPerformanceDto(value) {
    if (!('medianPrice' in value) || value['medianPrice'] === undefined)
        return false;
    if (!('annualGrowth' in value) || value['annualGrowth'] === undefined)
        return false;
    if (!('medianDaysOnMarket' in value) || value['medianDaysOnMarket'] === undefined)
        return false;
    return true;
}
function SuburbPerformanceDtoFromJSON(json) {
    return SuburbPerformanceDtoFromJSONTyped(json, false);
}
function SuburbPerformanceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'medianPrice': json['medianPrice'],
        'annualGrowth': json['annualGrowth'],
        'medianDaysOnMarket': json['medianDaysOnMarket'],
        'auctionClearanceRate': json['auctionClearanceRate'] == null ? undefined : json['auctionClearanceRate'],
        'totalListings': json['totalListings'] == null ? undefined : json['totalListings'],
        'demandLevel': json['demandLevel'] == null ? undefined : json['demandLevel'],
    };
}
function SuburbPerformanceDtoToJSON(json) {
    return SuburbPerformanceDtoToJSONTyped(json, false);
}
function SuburbPerformanceDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'medianPrice': value['medianPrice'],
        'annualGrowth': value['annualGrowth'],
        'medianDaysOnMarket': value['medianDaysOnMarket'],
        'auctionClearanceRate': value['auctionClearanceRate'],
        'totalListings': value['totalListings'],
        'demandLevel': value['demandLevel'],
    };
}
